import { Pipe, PipeTransform } from '@angular/core';
import { UserProfile } from '@content-platform/web-angular-administration-shared-data-access-graph-api';
import { MsGraphApiService } from '@content-platform/web-angular-administration-shared-data-access-ms-graph-api';
import { Observable, empty } from 'rxjs';

@Pipe({ name: 'userProfile' })
export class UserProfilePipe implements PipeTransform {
  constructor(private graphApi: MsGraphApiService) {}

  transform(userUUID: string): Observable<UserProfile> {
    if (!userUUID) {
      return empty();
    }
    return this.graphApi.getUser(userUUID);
  }
}
